import { Component, OnInit } from "@angular/core";
import { RequestService } from "../../../../modules/recruitment/requests/request.service";
import { UtilsService } from "../../../../auth/service/utils.service";

@Component({
  selector: "app-last-requests",
  templateUrl: "./last-requests.component.html",
  styleUrls: ["./last-requests.component.scss"],
})
export class LastRequestsComponent implements OnInit {
  public requestList: any = [];

  public arrayLength: number = 0;

  constructor(
    public _requestService: RequestService,
    public _utilService: UtilsService,
  ) {}

  async ngOnInit() {
    this.requestList = await this._requestService.getRequestList();
    this.requestList = this.requestList.filter((item: any) => {
      return item.closed === false;
    });
    this.requestList = this.requestList.sort((a: any, b: any) => b.id - a.id);
    this.arrayLength = this.requestList.length - 5;
    this.requestList = this.requestList.slice(0, 5);
  }
}
